// 端内/外
export enum ClientStatus {
  inApp = "0", // 端内
  webApp = "1", // 端外
}

export enum TabType {
  VALID = "VALID",
  USED = "USED",
  EXPIRED = "EXPIRED",
}

export const tabTypeMap = [TabType.VALID, TabType.USED, TabType.EXPIRED];
